<h2 mat-dialog-title>{{ 'Job Dictionary Configuration' | translate }}</h2>

<mat-dialog-content>
  @if (isLoading) {
    <div class="loading-wrap">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }

  @if (!isLoading) {
    <form class="job-dictionary-config-form">
      <p class="config-hint">
        {{ 'Choose which HRIS employee field drives the Job Dictionary. Rows built from this field are maintained by HRIS sync; editing a row makes it Manual.' | translate }}
      </p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Source Field' | translate }}</mat-label>
        <mat-select name="sourceKeyFieldType" required
          [(ngModel)]="sourceKeyFieldType"
          (ngModelChange)="onFieldChange()">
          @for (option of sourceFieldOptions; track trackByIndex($index)) {
            <mat-option
              [value]="option.value">
              {{ option.label | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Name Field (optional)' | translate }}</mat-label>
        <mat-select name="sourceNameFieldType"
          [(ngModel)]="sourceNameFieldType"
          (ngModelChange)="onFieldChange()">
          <mat-option [value]="null">{{ 'Use source field as name' | translate }}</mat-option>
          @for (option of sourceFieldOptions; track trackByIndex($index)) {
            <mat-option
              [value]="option.value">
              {{ option.label | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="cancel()">{{ 'Cancel' | translate }}</button>
  <button mat-flat-button color="primary" type="button"
    [disabled]="!canSave"
    (click)="save()">
    {{ 'Save' | translate }}
  </button>
</mat-dialog-actions>
